import { EMAIL_VALIDATION_REPORTS } from '@/store/actions/admin/email_validation_reports.actions';

const initialState = {
  email_validation_reports: [],
  email_validation_reports_meta: {}
};

export default function emailValidationReports(state = initialState, action) {
  switch (action.type) {
    case EMAIL_VALIDATION_REPORTS:
      return {
        ...state,
        email_validation_reports: action.payload.data,
        email_validation_reports_meta: action.payload.meta
      };
    default:
      return state;
  }
}
